"use client";

import type { FC } from "react";

interface Props {
  inspireMeAttributeId: number;
}

const ChaletSearchResultsIntroText: FC<Props> = ({ inspireMeAttributeId }) => {
  return (
    <div>
      {inspireMeAttributeId === 22 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <h1></h1>

              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1 className="display-3 fw-bold">
                      {" "}
                      Recommended Ski Chalets for Christmas Skiing in the Alps:
                      Snow-Sure and Family-Friendly
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                Looking to spend Christmas in a cosy ski chalet nestled in the
                snow-covered Alps? Whether you&apos;re planning a
                family-friendly ski holiday or looking for luxury ski chalets
                with guaranteed snow, we&apos;ve got you covered. The Alps offer
                some of the best Christmas ski chalets, perfect for enjoying the
                festive season in a true winter wonderland.
              </p>
              <p className="lead text-justify">
                Our top picks include family-friendly ski chalets in snow-sure
                resorts, where the whole family can enjoy Christmas skiing with
                peace of mind. If you&apos;re after a touch of luxury,
                we&apos;ve also curated a selection of chalets that provide not
                only stunning mountain views but also the perfect setting for a
                magical Christmas ski holiday.
              </p>
              <p className="lead text-justify">
                From the best Christmas skiing destinations in the Alps to
                affordable options for those seeking a budget-friendly getaway,
                we&apos;ve compiled the ultimate guide to finding the perfect
                ski chalet for your Christmas adventure. Whether you&apos;re
                dreaming of snow-sure Christmas skiing or a relaxing holiday in
                a charming chalet, the Alps have it all.
              </p>
            </div>
          </div>
        </div>
      )}
      {inspireMeAttributeId === 25 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1 className="display-3 fw-bold">
                      Celebrate New Year&apos;s Eve in the Alps - Ski Chalets
                      for an Unforgettable Start to the Year!
                    </h1>
                  </section>
                </div>
              </div>
              <p className="lead text-justify">
                Ready to ring in the New Year in a spectacular winter
                wonderland? Our selection of ski chalets for New Year&apos;s
                skiing in the Alps offers the ultimate festive experience,
                combining breathtaking alpine views, snow-sure conditions, and
                the excitement of the holiday season. Whether you&apos;re
                planning a lively New Year&apos;s Eve celebration or a serene
                getaway, we&apos;ve curated chalets that will make your winter
                holiday one to remember.
              </p>
              <p className="lead text-justify">
                For those looking to start the year off with adventure, the Alps
                provide world-class skiing, from beginner-friendly slopes to
                challenging runs for seasoned skiers. After a thrilling day on
                the slopes, enjoy a cozy evening in one of our handpicked
                chalets, perfect for a group celebration or an intimate retreat.
                With options ranging from luxury accommodations to
                budget-friendly chalets, we ensure that every traveller can
                enjoy the perfect New Year ski escape.
              </p>
              <p className="lead text-justify">
                Imagine spending New Year&apos;s Eve under the stars, surrounded
                by snow-capped peaks, and waking up to a fresh day of skiing in
                some of the most scenic resorts in the world. Whether you prefer
                the lively atmosphere of après-ski parties or a quiet evening by
                the fire, these chalets provide the ideal setting for a
                memorable celebration. Start the year off right by booking your
                New Year ski holiday in the Alps now!
              </p>
              <p className="lead text-justify">
                Explore our top-rated New Year&apos;s ski chalets below and find
                the perfect match for your holiday. Whether you&apos;re seeking
                a high-end luxury chalet or a charming, affordable stay,
                we&apos;ve got options that cater to all budgets and
                preferences. Let us help you plan an unforgettable New Year ski
                adventure in the Alps!
              </p>
            </div>
          </div>
        </div>
      )}
      {inspireMeAttributeId === 1 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1 className="display-3 fw-bold">
                      Ski Resorts with Short Transfer Times – Maximise Your Time
                      on the Slopes
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                Nobody enjoys a long, exhausting journey before their holiday
                has even started. That&apos;s why we&apos;ve handpicked a range
                of ski resorts with transfer times under 90 minutes from the
                nearest airport—perfect for families with young children,
                weekend warriors, and anyone who prefers more skiing and less
                sitting.
              </p>
              <p className="lead text-justify">
                These resorts offer seamless access to the slopes without the
                faff of lengthy coach rides through winding mountain roads.
                Whether you&apos;re landing in Geneva, Innsbruck, or Salzburg,
                you&apos;ll be gliding through fresh powder in no time. Ideal
                for shorter ski breaks or those arriving on early flights, these
                destinations make spontaneous alpine getaways wonderfully
                achievable.
              </p>
              <p className="lead text-justify">
                Short transfer resorts don&apos;t skimp on quality either.
                You&apos;ll find everything from charming Alpine villages to
                well-connected ski domains with plenty of runs and reliable
                snow. Save time, skip the travel fatigue, and squeeze every
                ounce of joy from your mountain escape.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 2 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1 className="display-3 fw-bold">
                      High Altitude Ski Resorts – Snow Sure, Season Long
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                If you&apos;re chasing dependable snow and the thrill of skiing
                well into the season, high altitude resorts are your best bet.
                Sitting at lofty elevations, these resorts boast longer seasons,
                colder temperatures, and higher snowfall—giving you peace of
                mind that your holiday won&apos;t be a washout.
              </p>
              <p className="lead text-justify">
                From glacier-backed giants like Tignes and Hintertux to lofty
                gems like Obergurgl and Val Thorens, these resorts are ideal for
                early or late season trips. With altitudes often exceeding 1,800
                metres, they deliver excellent conditions when lower resorts are
                patchy or closed entirely.
              </p>
              <p className="lead text-justify">
                Expect crisp mornings, squeaky snow, and postcard-perfect
                panoramas. And it&apos;s not just about quantity—many of these
                destinations invest heavily in snowmaking and piste maintenance,
                ensuring consistent coverage even in unpredictable seasons.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 3 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1 className="display-3 fw-bold">
                      Drive to the Slopes – Ski Resorts Within 1,000 KM of
                      Calais
                    </h1>
                  </section>
                </div>
              </div>
              <p className="lead text-justify">
                Planning a ski holiday by car? Resorts within 1,000 KM of Calais
                are ideal for British skiers looking to skip the airport queues
                and hit the road instead. Offering flexibility, comfort, and
                often lower costs, driving to the Alps is increasingly popular
                among families and groups.
              </p>
              <p className="lead text-justify">
                These accessible destinations offer excellent snow conditions
                without the need for a flight. Pack your gear, load the roof
                box, and enjoy a picturesque journey through France or Germany,
                arriving at your chalet ready to ski.
              </p>
              <p className="lead text-justify">
                Whether you&apos;re chasing fresh powder or planning a
                spontaneous weekend break, our handpicked resorts make it easy.
                Drive-safe, snow-sure, and perfect for adventurers who love the
                open road.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 4 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>Family Friendly Ski Resorts – Fun for All Ages</h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                When planning a ski holiday with children or extended family,
                the right resort makes all the difference. Our family-friendly
                ski resorts are designed with convenience, comfort, and safety
                in mind—so you can focus on creating unforgettable memories in
                the mountains.
              </p>
              <p className="lead text-justify">
                From dedicated nursery slopes and expert ski schools to
                childcare services and après-ski activities for little ones,
                these resorts cater to every member of the family. Many also
                feature snow parks, sledging areas, and indoor fun for rest
                days.
              </p>
              <p className="lead text-justify">
                Whether it’s a multi-generational holiday or a first-time ski
                trip with toddlers, our handpicked chalets and resorts ensure
                everyone—from grandparents to toddlers—has a magical alpine
                experience.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 6 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      Intermediate Ski Resorts – Perfect Pistes for Progression
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                Ready to move beyond the nursery slopes? Resorts ideal for
                intermediates offer the perfect mix of challenge and comfort.
                Cruise through long blues, test yourself on reds, and dip into
                moguls or gentle off-piste—all while building your technique and
                confidence.
              </p>
              <p className="lead text-justify">
                These destinations offer well-groomed pistes, great ski lift
                networks, and terrain that keeps you interested all day. Many
                are also part of large ski areas, meaning endless options
                without overwhelming complexity.
              </p>
              <p className="lead text-justify">
                Whether you&apos;re perfecting parallel turns or carving clean
                lines, these resorts provide just the right level of adventure.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 7 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      Advanced Ski Resorts – Steep, Deep, and Totally Worth It
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                For seasoned skiers who eat blacks for breakfast, our
                advanced-level resorts deliver. Expect steep descents, technical
                terrain, and jaw-dropping off-piste opportunities that will push
                you to your limits—in the best way possible.
              </p>
              <p className="lead text-justify">
                These resorts often host World Cup races, feature backcountry
                routes, and offer heli-skiing or ski touring for those craving
                adrenaline. They’re not for the faint-hearted, but that’s the
                point.
              </p>
              <p className="lead text-justify">
                When you&apos;re ready to step beyond the basics, these
                mountains will rise to meet you.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 8 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      Apres-Ski Resorts – Because the Fun Shouldn&apos;t Stop at
                      the Lift
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                For some, the real magic begins once the boots come off. If your
                ski holiday needs dancing on tables, live DJs, or just a
                cracking mulled wine by the fire, these resorts are for you.
              </p>
              <p className="lead text-justify">
                Known for their lively après-ski scenes, these destinations
                offer mountain bars, buzzing nightlife, and the kind of
                camaraderie you only get after a shared tumble in powder. Think
                La Folie Douce, Austrian umbrella bars, and chalet parties that
                go well into the night.
              </p>
              <p className="lead text-justify">
                From glam to grunge, every kind of après crowd has its home
                here.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 9 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>Ski-in/Ski-out Chalets – Slope Access Made Seamless</h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                Forget trudging through town in ski boots—these resorts offer
                true ski-in/ski-out convenience. Simply clip in outside your
                door, glide to the lifts, and ski back home at day&apos;s end.
              </p>
              <p className="lead text-justify">
                Especially ideal for families, first-timers, and early risers
                chasing first tracks, these accommodations maximise your
                mountain time while keeping logistics to a minimum.
              </p>
              <p className="lead text-justify">
                Because skiing should be about freedom, not faff.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 22 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>Christmas Ski Holidays – Make it a White Christmas</h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                Dreaming of a Christmas surrounded by snow, mountains, and the
                glow of chalet lights? A ski holiday during the festive season
                is pure magic. Wake up to crisp mountain air, enjoy festive
                feasts, and carve your way through pristine pistes.
              </p>
              <p className="lead text-justify">
                Resorts that shine at Christmas offer snow-sure conditions,
                family-friendly fun, and plenty of yuletide atmosphere. Think
                twinkling lights, horse-drawn sleigh rides, mulled wine by the
                fire, and carols echoing off the snow-covered slopes.
              </p>
              <p className="lead text-justify">
                Whether you&apos;re bringing kids for their first snowy
                Christmas or planning a romantic escape, our top picks guarantee
                a festive season to remember.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 25 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      New Year Ski Holidays – Start Your Year at the Summit
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                Ring in the New Year surrounded by snow-capped peaks and Alpine
                charm. Ski resorts during this period are buzzing with
                energy—from torchlight descents and mountain fireworks to lively
                après-ski parties.
              </p>
              <p className="lead text-justify">
                These destinations offer the perfect blend of celebration and
                serenity. Enjoy champagne by the fire or dance the night away in
                a snowy village square—either way, it&apos;ll be a New Year to
                remember.
              </p>
              <p className="lead text-justify">
                Ideal for groups, couples, or families looking to celebrate in a
                truly spectacular setting.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 24 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      Easter Ski Holidays – Sunshine, Snow, and Family Time
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                Late-season skiing does&apos;’t get much better than Easter in
                the Alps. With longer days, softer snow, and plenty of
                sun-drenched terraces, it’s a great time for relaxed skiing and
                family fun.
              </p>
              <p className="lead text-justify">
                These resorts have high-altitude slopes and glacier access,
                keeping conditions reliable well into April. Easter also brings
                family deals, egg hunts in the snow, and the kind of spring
                skiing that pairs perfectly with a cold drink in hand.
              </p>
              <p className="lead text-justify">
                If you love skiing without the winter chill, Easter is your
                golden window.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 23 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      Half-Term Ski Holidays – School&apos;s Out, Slopes Are In
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                When half-term hits, there&apos;s no better classroom than the
                mountains. Our selected resorts balance family-friendly fun with
                reliable snow and efficient infrastructure to keep the kids (and
                grown-ups) happy.
              </p>
              <p className="lead text-justify">
                Expect great ski schools, gentle beginner runs, and plenty of
                activities off the slopes too—from snow tubing and tobogganing
                to swimming and cinema nights.
              </p>
              <p className="lead text-justify">
                These destinations are well-versed in hosting families,
                especially during busy weeks, and know how to make your break
                smooth, safe, and full of snowy smiles.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 311 && (
        <div>
          <div className="row">
            <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
              <section className="text-center py-5  text-white position-relative overflow-hidden">
                <h1>Family-Friendly Ski Holidays</h1>
              </section>
            </div>
          </div>

          <p>
            Looking for a family-friendly ski holiday? We&apos;ve rounded up the
            best chalets in top-rated resorts where the whole family can enjoy
            skiing in a safe and enjoyable environment, with activities and
            amenities for all ages.
          </p>
        </div>
      )}
      {inspireMeAttributeId === 411 && (
        <div>
          <div className="row">
            <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
              <section className="text-center py-5  text-white position-relative overflow-hidden">
                <h1>Budget-Friendly Ski Holidays</h1>
              </section>
            </div>
          </div>
          <p>
            Planning a budget-friendly ski holiday? We&apos;ve handpicked
            affordable yet charming ski chalets that offer excellent value
            without compromising on quality, ensuring you get the best
            experience for your money.
          </p>
        </div>
      )}

      {inspireMeAttributeId === 14 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      Early Season Ski Holidays – First Tracks and Fresh Powder
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                If you&apos;re itching to ski before Christmas, early season
                resorts are where winter truly begins. With glacier access,
                snowmaking technology, and high-altitude slopes, these
                destinations open their lifts as early as November.
              </p>
              <p className="lead text-justify">
                Avoid the crowds, enjoy uncrowded pistes, and soak up the
                excitement of a fresh season just starting to unfold. Whether
                you&apos;re a keen skier or just want to beat the rush, early
                season trips offer excellent conditions and unbeatable value.
              </p>
              <p className="lead text-justify">
                Start your winter on a high note—literally.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 15 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>Late Season Ski Holidays – Sunshine and Soft Snow</h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                As the days grow longer and the sun shines brighter, late season
                skiing becomes a relaxed and joyful affair. Think spring snow,
                quieter slopes, and lunch on sunny terraces—bliss.
              </p>
              <p className="lead text-justify">
                Resorts good for late season skiing sit high above sea level or
                offer glacier access, keeping the snow reliable well into April.
                Perfect for Easter, longer days, and soft turns.
              </p>
              <p className="lead text-justify">
                For those who like their skiing served with a side of sun.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 17 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      Ski Resorts with Scenic Views – Mountains Made for
                      Memories
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                Some resorts offer more than just skiing—they deliver
                jaw-dropping beauty at every turn. From dramatic peaks and
                frozen lakes to sun-drenched valleys, these scenic spots are a
                feast for the senses.
              </p>
              <p className="lead text-justify">
                Perfect for photographers, romantics, and anyone who appreciates
                nature at its most magnificent. Whether you&apos;re riding the
                gondola or sipping vin chaud on a chalet balcony, the views
                alone are worth the trip.
              </p>
              <p className="lead text-justify">
                Because let&apos;s face it—alpine beauty is half the point.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 20 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      Large Ski Areas – Endless Slopes, Limitless Adventure
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                If variety is your thing, head straight to one of Europe&apos;s
                vast ski domains. Linked resorts, hundreds of kilometres of
                pistes, and enough runs to keep even the most insatiable skier
                entertained for a week—or more.
              </p>
              <p className="lead text-justify">
                These areas are perfect for confident skiers, mixed-ability
                groups, and anyone who hates doing the same run twice. Explore
                new valleys daily and enjoy the thrill of a proper ski safari.
              </p>
              <p className="lead text-justify">
                When one resort simply isn&apos;t enough.
              </p>
            </div>
          </div>
        </div>
      )}

      {inspireMeAttributeId === 21 && (
        <div className="container my-5">
          <div className="row">
            <div className="mx-auto">
              <div className="row">
                <div className="col-12 col-lg-9 col-xl-10 offset-lg-3 offset-xl-2 p-4">
                  <section className="text-center py-5  text-white position-relative overflow-hidden">
                    <h1>
                      Off-Piste Ski Resorts – For the Brave, the Bold, and the
                      Powder Hounds
                    </h1>
                  </section>
                </div>
              </div>

              <p className="lead text-justify">
                If you&apos;re the type to eye the untouched snow beside the
                piste, these are your playgrounds. Known for their off-piste
                terrain, these resorts offer powder fields, couloirs, and
                forests that challenge and thrill.
              </p>
              <p className="lead text-justify">
                Whether you&apos;re hiring a guide or exploring known routes,
                make sure your avalanche gear and your sense of adventure are
                packed. It&apos;s not just skiing—it&apos;s exploring.
              </p>
              <p className="lead text-justify">
                For skiers who colour outside the lines.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChaletSearchResultsIntroText;
